














import { Component, Vue } from 'vue-property-decorator';
import Forms from '@/components/Forms.vue';
import { getSubscription, patchSubscription } from '../api/api';
import { BACKEND_URL } from '../helpers/constants';
import { legalForms } from '@/data/legalForms';
import { companyTypes } from '../data/companyTypes';
import get from 'lodash/get';
import FileCurrent from '@/models/FileCurrent';
import Subscription from '../models/Subscription';
import { Route } from 'vue-router';

let subscription: Subscription | null = null;

async function computeBreadcrumb(to: Route, from: Route, next: Function) {
    console.log('test');
    try {
        const { data: subscriptionObj } = await getSubscription(+to.params.id);
        subscription = subscriptionObj;

        to.meta.breadcrumb[2].title = to.params.id;
    } catch (error) {
        if (error.response.status == 404) {
            Vue.prototype.$vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: `Abonnement introuvable.`,
            });

            next({
                name: 'subscriptions',
            });
            return;
        }
    }

    next();
}

@Component({
    beforeRouteEnter: computeBreadcrumb,
    beforeRouteUpdate: computeBreadcrumb,
    components: {
        Forms,
    },
})
export default class SubscriptionForm extends Vue {
    subscription: Subscription | null = subscription;
    loading: boolean = false;
    errors: any = {};
    get type() {
        return this.$route.name === 'edit';
    }
    get items() {
        return [
            {
                name: 'end_at',
                label: 'Date de fin',
                type: 'date',
            },
        ];
    }
    value: any | null = null;
    defaultValue: any = {
        end_at: null,
    };

    getValue(value: any) {
        this.value = value;
    }

    async created(): Promise<void> {
        this.loading = true;
        if (this.subscription) {
            this.defaultValue.end_at = this.subscription.end_at || null;
        }
        this.loading = false;
    }

    async submit(form: any) {
        this.loading = true;
        const newSubscription: Subscription = {
            end_at: form.end_at,
            payments: [],
        };
        const $vs = (this as any).$vs;
        try {
            await patchSubscription(+this.$route.params.id, newSubscription);
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Modification',
                text: `Modification de l'abonnement réussie`,
            });

            this.$router.push({ name: 'subscriptions' });
        } catch (error) {
            this.errors = get(error, 'response.data.errors.children', {});

            const message = get(
                error,
                'response.data.message',
                'Erreur lors de la soumission du formulaire'
            );
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        } finally {
            this.loading = false;
        }
    }
}
